import * as React from 'react';
import { formatNumber } from '@progress/kendo-intl';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

export default class ColorPercentCell extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field || this.props.rowType !== 'data') return null;
    const value = this.props.dataItem[this.props.field];

    return (
      <td {...this.props.tdProps} className={[this.props.tdProps?.className, (value > 0) ? 'text-success' : (value < 0) ? 'text-danger' : ''].filter(Boolean).join(" ")}>
        {formatNumber(value, "p")}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return this.props.dataItem[this.props.field] !== nextProps.dataItem[this.props.field];
  }
}
